import axios from "axios";

export class MainService {
	static BASE_URL = "https://cartaoexpress.rx2.com.br/api";
	static BASE_URL_CRM_V3 = "https://painelcrm.rxy.com.br/api/v3";
	static async getCities() {
		try {
			const cities = await axios.get(`${this.BASE_URL}/branch/cities`, {
				headers: {
					"x-access-token": 'Jd3[6;_>[qH#F"Tm',
					"x-app-id": "midia-express",
					"x-app-build": "264",
				},
			});

			const citiesBeautiful = await Promise.all(
				cities.data.map((city, index) => ({
					value: city,
					label: city,
				})),
			);

			return citiesBeautiful;
		} catch (error) {
			console.error(error);
			return [];
		}
	}

	static async getSellers(city, name = "") {
		try {
			const ipAddress = await axios.get(
				"https://api.ipify.org?format=json",
			);
			let URL = `${this.BASE_URL}/users-by-branch?city=${city}`;
			if (name.length > 0) URL = `${URL}&name=${name}`;
			const sellersResponse = await axios.get(encodeURI(URL), {
				headers: {
					"x-access-token": 'Jd3[6;_>[qH#F"Tm',
					"x-app-id": "midia-express",
					"x-app-build": "264",
				},
			});
			try {
				const { branch = [] } = sellersResponse.data ?? {};

				await Promise.all(
					branch.map(async (b) => {
						try {
							const res = await axios.post(
								`${this.BASE_URL_CRM_V3}/traffic/log`,
								{
									url: `vendedores?city=${city}`,
									branchCode: b.longCode,
									ipAddress: ipAddress.data.ip,
								},
								{
									headers: {
										"x-api-key":
											"3bcc2506-3fa6-4fff-ac35-10877ff3c671",
										"x-app-id": "midia-express",
										"x-app-build": "264",
									},
								},
							);
							if (res.data?.data?.id) {
								localStorage.setItem(
									`trafficLogId_${b.longCode}`,
									String(res.data.data.id),
								);
							}
						} catch (err) {
							console.error(
								`Erro ao registrar TrafficLog da filial ${b.longCode}:`,
								err,
							);
						}
					}),
				);
			} catch (logError) {
				console.error(
					"Erro ao registrar TrafficLog por filial:",
					logError,
				);
			}

			return sellersResponse.data;
		} catch (error) {
			console.error(error);
			return [];
		}
	}

	static async saveSellerClick({
		userId,
		sellerName,
		sellerPhone,
		branchLongCode,
		whatsAppUrl,
	}) {
		try {
			const trafficLogIdKey = branchLongCode
				? `trafficLogId_${branchLongCode}`
				: "trafficLogId";
			const trafficLogIdStr =
				localStorage.getItem(trafficLogIdKey) ||
				localStorage.getItem("trafficLogId");

			if (!trafficLogIdStr) {
				console.warn("TrafficLogId não encontrado no localStorage.");
			}
			const payload = {
				trafficLogId: trafficLogIdStr
					? Number(trafficLogIdStr)
					: undefined,
				userId,
				sellerName,
				sellerPhone,
				branchLongCode,
				whatsAppUrl,
			};
			const res = await axios.post(
				`${this.BASE_URL_CRM_V3}/traffic/seller-click`,
				payload,
				{
					headers: {
						"Content-Type": "application/json",
						"x-api-key": "3bcc2506-3fa6-4fff-ac35-10877ff3c671",
						"x-app-id": "midia-express",
						"x-app-build": "264",
					},
				},
			);
			return res?.data ?? true;
		} catch (error) {
			console.error("Erro ao salvar SellerClickLog:", error);
			return false;
		}
	}

	static async saveClientInfo(clientName, clientCPF, clientPhone) {
		try {
			const sellersResponse = await axios.post(
				`${this.BASE_URL}/clients`,
				{
					name: clientName,
					cpf: clientCPF,
					phone: clientPhone,
				},
				{
					headers: {
						"x-access-token": 'Jd3[6;_>[qH#F"Tm',
						"x-app-id": "midia-express",
						"x-app-build": "264",
					},
				},
			);

			return sellersResponse.status === 201;
		} catch (error) {
			console.error(error);
			return false;
		}
	}

	static async getTabloidIfExists(branchId) {
		try {
			let URL = `${this.BASE_URL}/branch-tabloid-exists/${branchId}/exists`;

			const getTabloidResponse = await axios.get(encodeURI(URL));

			return getTabloidResponse.data.data.branchTabloid;
		} catch (error) {
			console.error(error);
			return null;
		}
	}

	static getURLTabloid(branchTabloidId) {
		return `${this.BASE_URL}/branch-tabloid-file/${branchTabloidId}/file`;
	}
}
